<div class="overlay" *ngIf="show">
	<div class="progress-container">
		<p-progressSpinner ariaLabel="loading" class="progress"></p-progressSpinner>
		<div class="progress-text">Your dashboards and reports are being prepared. Please wait while we process ...</div>
	</div>
</div>